import React from 'react'
import "./machining.css"



import { buildMachiningContext } from '../../../Utils/buildContext'
import mach from '../../../assets/mach1.png'


function Machining({lang}) {
  const context = buildMachiningContext(lang)

  const handleOnCLick = () =>{
    const el = document.getElementById("contact")
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <div id="machining-cut" className='machining-cut'>
      <div className="left">
        <h2>{context.title}</h2>
        <p>{context.text}</p>
      </div>

      <div className="right">
        <img src={mach} alt="machining" className="machining-img" />
        
        <div className="infos">
          <h2>{context.sub_title}</h2>
          <button onClick={handleOnCLick}>{context.button_text}</button>
        </div>
      </div>
    </div>
  )
}

export default Machining
